import { configureStore as rtkConfigureStore, combineReducers } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import legacyReducers from './reducers';
import { api } from './v2/app/api';

export const history = createBrowserHistory();

const rootReducer = combineReducers({
    router: connectRouter(history),
    ...legacyReducers,
    [api.reducerPath]: api.reducer,
});

export default function configureStore(initialState = {}) {
    return rtkConfigureStore({
        reducer: rootReducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                // Legacy modules store moment instances and Structure class instances
                // directly in state. RTK's serializability + immutability checks would
                // both warn loudly and slow dev to a crawl, so they're off here.
                serializableCheck: false,
                immutableCheck: false,
            }).concat(routerMiddleware(history), api.middleware),
    });
}
